var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreativecopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 251.386,
    height: 140.839,
    viewBox: "0 0 251.386 140.839",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: -82.081,
    y1: 69.249,
    x2: -81.081,
    y2: 69.249,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1e902"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#f68521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f15b2d"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M405.552,827.99a4,4,0,0,0-1.844.446,4.69,4.69,0,0,0-1.518,1.235,4.1,4.1,0,0,0-.837,1.732,3.4,3.4,0,0,0-.075.717,2.778,2.778,0,0,0,.367,1.429,2.642,2.642,0,0,0,1.025,1,3.038,3.038,0,0,0,1.488.361,3.506,3.506,0,0,0,1.2-.21,4.5,4.5,0,0,0,1.114-.589.412.412,0,0,0,.108-.118.332.332,0,0,0,.052-.174.289.289,0,0,0-.066-.184v-.012a.32.32,0,0,0-.223-.087.383.383,0,0,0-.205.069,3.438,3.438,0,0,1-1.916.668,2.411,2.411,0,0,1-1.181-.287,2.057,2.057,0,0,1-.807-.783,2.186,2.186,0,0,1-.29-1.114,2.683,2.683,0,0,1,.067-.594,3.463,3.463,0,0,1,.688-1.409,4.289,4.289,0,0,1,1.294-1.07,3.152,3.152,0,0,1,1.495-.4,2.311,2.311,0,0,1,1.634.622.368.368,0,0,0,.235.1.277.277,0,0,0,.2-.089.289.289,0,0,0,.1-.223.371.371,0,0,0-.1-.238,2.65,2.65,0,0,0-.891-.594,2.928,2.928,0,0,0-1.084-.207.149.149,0,0,0-.028,0",
    transform: "translate(-401.278 -827.99)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: -38.382,
    y1: -27.413,
    x2: -38.253,
    y2: -27.413,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f15b2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#c74c27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#9c4323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#792f18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#562619"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#3a1912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#26140f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#1c1716"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#151414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#090a0a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#010101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M439.242,833.865a.329.329,0,0,0-.336.292l-1.114,5.214a.31.31,0,0,0-.013.1.275.275,0,0,0,.267.289h.025a.343.343,0,0,0,.34-.3l.618-2.894a2.617,2.617,0,0,1,.541-1.148,2.316,2.316,0,0,1,.843-.648,2.221,2.221,0,0,1,.891-.2,1.373,1.373,0,0,1,1.014.445.316.316,0,0,0,.221.084.338.338,0,0,0,.207-.074l.013-.011.013-.013a.3.3,0,0,0,.087-.212.322.322,0,0,0-.066-.2,1.153,1.153,0,0,0-.34-.3,2.337,2.337,0,0,0-.522-.248,1.752,1.752,0,0,0-.587-.1,3.022,3.022,0,0,0-1.723.573,2.138,2.138,0,0,0-.177.141l.089-.418a.3.3,0,0,0,0-.077.275.275,0,0,0-.264-.287h-.015c0-.007-.008-.007-.013,0",
    transform: "translate(-437.778 -833.864)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: -58.895,
    y1: -40.388,
    x2: -58.733,
    y2: -40.388,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M465.818,835.269a3.538,3.538,0,0,1,1.039-.815,2.584,2.584,0,0,1,1.173-.289,1.979,1.979,0,0,1,1.035.266,1.831,1.831,0,0,1,.911,1.559.649.649,0,0,1,0,.113h-4.709a3.361,3.361,0,0,1,.551-.833m2.256-1.737a3.319,3.319,0,0,0-1.583.412,4.179,4.179,0,0,0-1.309,1.1,3.638,3.638,0,0,0-.724,1.5,2.933,2.933,0,0,0-.069.61,2.488,2.488,0,0,0,.318,1.245,2.313,2.313,0,0,0,.891.891,2.6,2.6,0,0,0,1.283.322,3.251,3.251,0,0,0,1.171-.213,4.51,4.51,0,0,0,1.024-.554.333.333,0,0,0,.11-.128.342.342,0,0,0,.033-.149.288.288,0,0,0-.064-.19.331.331,0,0,0-.436-.074,5.54,5.54,0,0,1-.532.335,2.666,2.666,0,0,1-.573.221,2.325,2.325,0,0,1-.678.112,1.914,1.914,0,0,1-.984-.248,1.719,1.719,0,0,1-.668-.668,1.93,1.93,0,0,1-.24-.956,2.5,2.5,0,0,1,.028-.367h5.137a.335.335,0,0,0,.341-.269v-.011a2.425,2.425,0,0,0-1.147-2.569l.007,0a2.54,2.54,0,0,0-1.285-.348c-.018,0-.036,0-.052,0",
    transform: "translate(-464.389 -833.53)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: -40.751,
    y1: -32.208,
    x2: -40.622,
    y2: -32.208,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M506.416,838.758a1.816,1.816,0,0,1-.681-.679,1.9,1.9,0,0,1-.246-.958,2.263,2.263,0,0,1,.049-.469,2.794,2.794,0,0,1,.612-1.211,3.729,3.729,0,0,1,1.114-.909,2.6,2.6,0,0,1,1.209-.335,1.975,1.975,0,0,1,.981.249,1.816,1.816,0,0,1,.689.684,1.9,1.9,0,0,1,.251.971,2.506,2.506,0,0,1-.041.469,2.786,2.786,0,0,1-.612,1.2,3.756,3.756,0,0,1-1.132.9,2.676,2.676,0,0,1-1.234.331h-.03a1.852,1.852,0,0,1-.93-.246m2.113-5.188a3.3,3.3,0,0,0-1.559.412,4.317,4.317,0,0,0-1.337,1.1,3.466,3.466,0,0,0-.735,1.5,2.856,2.856,0,0,0-.069.6,2.454,2.454,0,0,0,1.222,2.143,2.5,2.5,0,0,0,1.253.325,3.252,3.252,0,0,0,1.185-.223,4.061,4.061,0,0,0,1.114-.642,4.106,4.106,0,0,0,.345-.31l-.139.669-.013.071v.015a.277.277,0,0,0,.269.287h.028a.353.353,0,0,0,.343-.3l1.1-5.2a.34.34,0,0,0,.013-.107.276.276,0,0,0-.264-.287h-.028a.335.335,0,0,0-.244.1.457.457,0,0,0-.1.2l-.187.891a2.426,2.426,0,0,0-1.084-1,2.6,2.6,0,0,0-1.083-.236h-.028",
    transform: "translate(-504.829 -833.57)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: -37.262,
    y1: -29.867,
    x2: -37.14,
    y2: -29.867,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M548.259,827.16a.331.331,0,0,0-.335.292l-.272,1.3h-.576a.321.321,0,0,0-.336.267.276.276,0,0,0,.289.345h.494l-.773,3.65a1.225,1.225,0,0,0-.031.279.913.913,0,0,0,.172.556.777.777,0,0,0,.523.289,2.832,2.832,0,0,0,.39.021.312.312,0,0,0,.327-.176.418.418,0,0,0,.038-.159.3.3,0,0,0-.3-.29.123.123,0,0,0-.035,0h-.176a.3.3,0,0,1-.223-.072.354.354,0,0,1-.074-.233.715.715,0,0,1,.02-.156l.778-3.708h.891a.329.329,0,0,0,.223-.08.366.366,0,0,0,.087-.113l.02-.02.012-.062a.285.285,0,0,0-.059-.241.271.271,0,0,0-.223-.1h-.817l.264-1.229v-.069a.282.282,0,0,0-.272-.292h-.015a.014.014,0,0,0-.012,0",
    transform: "translate(-546.718 -827.16)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: -195.713,
    y1: -63.404,
    x2: -195.408,
    y2: -63.404,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M561.034,839.75a.765.765,0,0,0,0,.087.284.284,0,0,0,.276.29h.023a.341.341,0,0,0,.338-.3l1.125-5.275-.154-.061c-.077-.028-.151-.059-.223-.093l-.223-.1Z",
    transform: "translate(-561.032 -834.3)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: -433.448,
    y1: -115.906,
    x2: -432.981,
    y2: -115.906,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "n"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M577.444,842.488a.293.293,0,0,0,.108.189.281.281,0,0,0,.171.061h.02a.306.306,0,0,0,.151-.041.392.392,0,0,0,.146-.138l3.248-5.106-.466.105c-.107.025-.223.044-.327.066l-.082.016-2.518,3.974-.866-4.033-.12-.026-.259-.061-.3-.074Z",
    transform: "translate(-576.35 -837.42)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: -66.035,
    y1: -46.187,
    x2: -65.868,
    y2: -46.187,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "p"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M605.229,834.724c-.093.038-.184.074-.271.1l-.1.036-1.089,5.107a.491.491,0,0,0,0,.1.282.282,0,0,0,.272.29h.025a.338.338,0,0,0,.336-.3l1.168-5.485Z",
    transform: "translate(-603.765 -834.58)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: -417.429,
    y1: -114.236,
    x2: -416.973,
    y2: -114.236,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M618.992,827.148a.317.317,0,0,0-.223.187l-.016.039c-.005.02-.01.038-.013.057l-.28,1.307h-.583a.316.316,0,0,0-.336.267.274.274,0,0,0,.287.345h.5l-.774,3.65a1.327,1.327,0,0,0-.03.279.914.914,0,0,0,.174.556.774.774,0,0,0,.523.289,2.815,2.815,0,0,0,.391.021.314.314,0,0,0,.326-.176.417.417,0,0,0,.036-.159.3.3,0,0,0-.3-.29.125.125,0,0,0-.035,0h-.175a.308.308,0,0,1-.223-.072.35.35,0,0,1-.071-.233.822.822,0,0,1,.018-.156l.791-3.709h.891a.339.339,0,0,0,.31-.194l.02-.02v-.062a.275.275,0,0,0-.2-.33.311.311,0,0,0-.077-.007H619.1l.262-1.229v-.069a.282.282,0,0,0-.272-.292h-.028a.269.269,0,0,0-.036,0,.259.259,0,0,0-.038,0",
    transform: "translate(-617.518 -827.148)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: -197.669,
    y1: -63.504,
    x2: -197.366,
    y2: -63.504,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "t"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M635.154,833.878a.309.309,0,0,0-.164.1.347.347,0,0,0-.076.223.321.321,0,0,0,0,.079l1.065,5.135-1.058,1.683a.331.331,0,0,0-.041.152.322.322,0,0,0,.089.223.3.3,0,0,0,.223.092.3.3,0,0,0,.143-.029.379.379,0,0,0,.146-.146l4.454-7.074v-.025a.408.408,0,0,0,.023-.115.3.3,0,0,0-.3-.305.345.345,0,0,0-.157.039.353.353,0,0,0-.136.133l-2.894,4.6-.94-4.533a.312.312,0,0,0-.3-.241.258.258,0,0,0-.071.008",
    transform: "translate(-634.88 -833.869)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: -64.513,
    y1: -30.992,
    x2: -64.35,
    y2: -30.992,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "v"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M553.273,811.557a.386.386,0,0,0-.052.543,8.314,8.314,0,0,0,12.275.218.385.385,0,1,0-.574-.513,7.543,7.543,0,0,1-11.105-.194.387.387,0,0,0-.543-.054",
    transform: "translate(-553.132 -811.47)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: -13.919,
    y1: 26.52,
    x2: -13.854,
    y2: 26.52,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "x",
    x: 104.006,
    y: 97.099,
    width: 147.38,
    height: 43.74,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "y"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "y"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1777.338 -1831.281)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1777.338 1831.281)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.323)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375.568,115.957a2.374,2.374,0,0,0,1.114.238,49.846,49.846,0,0,0,5.544-1.2,10.808,10.808,0,0,1-1.38-2.251s-.235.756-.563.784c-.8.067-.812-.679-.925-1.05s-2.761-2.216-2.566-2.915,2.3-.328,2.3-.328-1.045-.448-1.826-2.914.112-4.054,1.273-5.686,4.72-2.723,7.2-2.338a4.711,4.711,0,0,1,3.7,3.647,21.135,21.135,0,0,1,.34,3.371c.689-1.565,2.212-1.148,2.317-.663s-.683,2.65-.487,3.511.453,1.262.034,1.439a3.071,3.071,0,0,1-1.36-.051,9.465,9.465,0,0,1,.248,1.742,19.328,19.328,0,0,1-.753,2.235,8.055,8.055,0,0,0,3.268-.784,3.271,3.271,0,0,0,1.36-2.111s-1.892-12.139-2.054-13.166-1.188-1.92-3.685-2.156-10.249,1.849-13.3,2.121-2.661,2.318-2.661,2.318l2.443,15.42C375.2,115.69,375.186,115.7,375.568,115.957Z",
    transform: "translate(-352.229 -95.297)",
    fill: "#4b1d1b"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 17.968)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265.459,150.033a18.258,18.258,0,0,1-.041-5.439c.144-1.211,2.755-9,3.875-10.515s10.306-4.185,10.306-4.185-.277-.548-.622-1.1c-5.084.94-10.349,1.951-13.494,2.628-4.818,1.037-4.9,4.851-4.9,4.851v16.359c0,.059,0,.118,0,.177.011.251-.016,1.047-.041,1.777l-.061.025c-.617.228-4.663.773-5.329,1.037a12.136,12.136,0,0,0-5.585,3.132,5.47,5.47,0,0,0-.943,6.517,3.412,3.412,0,0,0,.727.96c2.8,2.623,7.37,2.377,7.37,2.377,8.516.007,8.274-8.359,8.274-8.359a22.558,22.558,0,0,1,.31-5.051,26.131,26.131,0,0,0,.015-3.759C265.371,151,265.417,150.518,265.459,150.033Z",
    transform: "translate(-247.955 -126.212)",
    fill: "#4b1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.356,117.1c-.133-4.8-5.616-4.069-7.663-3.842-.73.077-3.5.548-7.091,1.186a1.46,1.46,0,0,0,.341,1.122c.5.358,2.691.569,3.1,1.035s3.414,1.237,4.307,1.664,1.959,2.554,2.171,3.193.855.978,1.276,1.787.638,3.959.724,4.682.451,1.675.11,2.271a1.418,1.418,0,0,0-.2,1.59c.3.809.213.9.074,2.607-.2,2.487-4.843,5-4.843,5l-3.582.2a13.87,13.87,0,0,1-1.514.458,14.58,14.58,0,0,0-5.791,3.245c-2.922,2.445-1.811,5.955-1.222,7.12a3.7,3.7,0,0,0,.783,1.032c3.011,2.819,7.918,2.554,7.918,2.554,11.43-.282,11.1-8.984,11.1-8.984S463.487,121.9,463.356,117.1Z",
    transform: "translate(-410.873 -113.076)",
    fill: "#4b1d1b"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.867 18.87) rotate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.762 12.384)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.335,2.315a1.68,1.68,0,0,1,.932-.953c.166-.066.5-.164.584-.3C3.143.614,2.8-.085,2.3.009A4.517,4.517,0,0,0,.5.63,4.6,4.6,0,0,0,0,1.89",
    transform: "translate(0.108 0.112)",
    fill: "#0b0c0c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.549,2.462l-.21-.069a1.781,1.781,0,0,1,1-1.022l.107-.041a1.2,1.2,0,0,0,.425-.217A.646.646,0,0,0,2.843.426a.414.414,0,0,0-.413-.2A4.213,4.213,0,0,0,.684.814,4.22,4.22,0,0,0,.218,2.027L0,1.973A4.379,4.379,0,0,1,.52.665,4.723,4.723,0,0,1,2.384.009.62.62,0,0,1,3.02.3a.86.86,0,0,1,.03.932,1.13,1.13,0,0,1-.533.3l-.1.038A1.587,1.587,0,0,0,1.549,2.462Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17,.807S17-.321,15.679.09c0,0-5.846,9.5-6.251,10.024s-4.006,7.165-4.586,8.2S.1,25.856.011,25.947s.413.678.755.728a2.408,2.408,0,0,0,.876-.136s3.737-6.915,4.152-7.7,5.015-7.954,5.506-8.594S14.812,4.561,15.383,3.6,17,.807,17,.807Z",
    transform: "translate(0.199 0.201)",
    fill: "#0b0c0c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.089,27.078a2.842,2.842,0,0,0,.81-.159l.071-.025.036-.066c.036-.069,3.747-6.937,4.154-7.7s4.971-7.89,5.49-8.567c.5-.653,3.518-5.69,4.1-6.668.561-.948,1.606-2.773,1.614-2.792l.025-.044V1.005a1.087,1.087,0,0,0-.389-.82A1.281,1.281,0,0,0,15.818.108l-.069.021L15.712.19c-.057.1-5.844,9.5-6.239,10.011-.294.382-2.02,3.519-3.764,6.7-.4.722-.7,1.283-.84,1.529-.577,1.034-4.659,7.4-4.8,7.586a.247.247,0,0,0-.046.267,1.514,1.514,0,0,0,.911.784,1.309,1.309,0,0,0,.158.01ZM.4,26.2c.532-.778,4.279-6.643,4.805-7.581.138-.246.446-.81.842-1.531,1.2-2.189,3.431-6.261,3.729-6.651.4-.51,5.673-9.087,6.223-9.982a.883.883,0,0,1,.763.041A.669.669,0,0,1,17,.957c-.172.3-1.076,1.879-1.583,2.74-.7,1.18-3.6,6.023-4.069,6.63-.522.683-5.115,7.852-5.524,8.621-.389.732-3.729,6.912-4.118,7.632a1.966,1.966,0,0,1-.717.1A1.262,1.262,0,0,1,.4,26.2Zm-.061.089c.01-.011.018-.023.026-.034A.107.107,0,0,1,.344,26.284Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.817 10.121)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.077,1.075A.7.7,0,0,1,.38.133.717.717,0,0,1,.508.082,2.573,2.573,0,0,1,2.925.714c.24.482.238,1.03-.441,1.107S1.381,1.187.077,1.075Z",
    transform: "translate(0.101 0.109)",
    fill: "#0b0c0c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.6,2.042A.729.729,0,0,0,3.2,1.7,1.012,1.012,0,0,0,3.125.777,2.634,2.634,0,0,0,.574.088.809.809,0,0,0,.055.529a.945.945,0,0,0,.025.7l.026.059.064,0a3.547,3.547,0,0,1,1.467.471,1.833,1.833,0,0,0,.847.285A.907.907,0,0,0,2.6,2.042ZM.256.611A.609.609,0,0,1,.644.3a2.5,2.5,0,0,1,2.28.578A.811.811,0,0,1,3,1.589a.527.527,0,0,1-.436.233,1.463,1.463,0,0,1-.833-.254A3.8,3.8,0,0,0,.256,1.08.7.7,0,0,1,.256.611Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.06 8.299)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.056.789A.516.516,0,0,1,.283.1.46.46,0,0,1,.376.059,1.9,1.9,0,0,1,2.158.525c.177.354.177.76-.326.815S1.019.872.056.789Z",
    transform: "translate(0.077 0.086)",
    fill: "#0b0c0c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.916,1.507a.539.539,0,0,0,.446-.256A.74.74,0,0,0,2.305.573,1.941,1.941,0,0,0,.425.066.6.6,0,0,0,.041.39.7.7,0,0,0,.059.908L.076.951l.051,0A2.634,2.634,0,0,1,1.209,1.3a1.357,1.357,0,0,0,.622.21A.5.5,0,0,0,1.916,1.507ZM.192.8a.512.512,0,0,1,0-.343A.447.447,0,0,1,.478.222,1.843,1.843,0,0,1,2.159.647a.6.6,0,0,1,.057.528.392.392,0,0,1-.323.172,1.055,1.055,0,0,1-.615-.187A2.756,2.756,0,0,0,.192.8Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.638 8.967)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.077,1.053A.7.7,0,0,1,.382.113.629.629,0,0,1,.508.064,3.912,3.912,0,0,1,3.514.9c.24.482.238,1.03-.443,1.107S1.381,1.164.077,1.053Z",
    transform: "translate(0.104 0.108)",
    fill: "#0b0c0c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.186,2.219a.729.729,0,0,0,.605-.346A1.012,1.012,0,0,0,3.715.954C3.434.388,1.352-.2.576.066a.812.812,0,0,0-.52.441.944.944,0,0,0,.023.7l.028.059.064,0a5.281,5.281,0,0,1,1.78.574,3.022,3.022,0,0,0,1.14.379A.923.923,0,0,0,3.186,2.219ZM.258,1.059a.7.7,0,0,1,0-.469A.611.611,0,0,1,.647.273a3.929,3.929,0,0,1,2.876.776.811.811,0,0,1,.077.715A.525.525,0,0,1,3.163,2a2.507,2.507,0,0,1-1.119-.354A5.659,5.659,0,0,0,.258,1.059Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.747 11.388)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.96,1.227a.509.509,0,0,0,.251-.5A2.113,2.113,0,0,0,.467.005C-.241.161.066,1.07.066,1.07a1.492,1.492,0,0,0,1.106.784c.077.01-.3-.635-.223-.622a2.412,2.412,0,0,0,1.011,0Z",
    transform: "translate(0.047 0.049)",
    fill: "#0b0c0c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.273,1.929c.03-.046.008-.1-.113-.356C1.125,1.5,1.076,1.4,1.054,1.34a2.22,2.22,0,0,0,.975-.015h0A.552.552,0,0,0,2.314.777c0-.064-.075-.153-.22-.264A2.236,2.236,0,0,0,.5.006.6.6,0,0,0,.09.293a1.177,1.177,0,0,0-.021.847,1.529,1.529,0,0,0,1.147.819h.039Zm.671-1.4c.192.135.264.226.264.249a.46.46,0,0,1-.22.45h0a2.308,2.308,0,0,1-.983,0H.964l-.021.031c-.031.044,0,.108.116.368.034.067.079.164.1.223a1.452,1.452,0,0,1-1-.746A1.105,1.105,0,0,1,.178.344.5.5,0,0,1,.525.1a.848.848,0,0,1,.2-.02A2.339,2.339,0,0,1,1.944.525Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.799 13.233)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4,12.315s-1.2-4.421-3.636-5.64l-.9-.02S9.886,5.086,9.118,4.281,6.131,1.078,5.476.622A5.98,5.98,0,0,0,1.893.072a.473.473,0,0,0-.384.546.461.461,0,0,0,.2.308,1.518,1.518,0,0,0,.894.261s1.178.212,1.585.281l.7.932A4.349,4.349,0,0,0,1.071,3.5s-1.176.335-1.063,1,1.063.574,1.063.574a7.814,7.814,0,0,0,1.823-.591,4.311,4.311,0,0,1,1.514.056,3.448,3.448,0,0,1,1.229.643A5.4,5.4,0,0,0,4.1,5.132a7.358,7.358,0,0,0-2.125.7c-.622.282-.377,1.061,0,1.088a9.324,9.324,0,0,0,1.337-.3,2.936,2.936,0,0,1,2.358.113c.3.148,1.039,1.872,2.077,2.589a3.762,3.762,0,0,0,2.656.42,4.629,4.629,0,0,1,1.672.532C13.333,10.835,16.4,12.315,16.4,12.315Z",
    transform: "translate(0.098 0.097)",
    fill: "#0b0c0c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.593,12.389c-.049-.184-1.244-4.476-3.685-5.7L12,6.659c-.233-.185-2.008-1.6-2.715-2.348l-.364-.389A42.623,42.623,0,0,0,5.627.637,6.092,6.092,0,0,0,1.975.073a.555.555,0,0,0-.458.438A.554.554,0,0,0,1.75,1.1a1.585,1.585,0,0,0,.932.276l1.549.274.532.7A4.618,4.618,0,0,0,1.121,3.5c-.169.051-1.23.407-1.112,1.107.1.6.809.691,1.163.658A7.607,7.607,0,0,0,3,4.677a4.214,4.214,0,0,1,1.477.054,3.192,3.192,0,0,1,.884.4,5.407,5.407,0,0,0-1.175,0,7.442,7.442,0,0,0-2.153.717.693.693,0,0,0-.423.778.554.554,0,0,0,.459.492,1.882,1.882,0,0,0,.692-.133,4.2,4.2,0,0,1,.664-.169c.107-.02.217-.048.333-.077a2.475,2.475,0,0,1,1.962.179,2.928,2.928,0,0,1,.466.648A6.693,6.693,0,0,0,7.778,9.5a3.807,3.807,0,0,0,2.72.438,4.75,4.75,0,0,1,1.632.525c1.242.548,4.292,2.02,4.323,2.034l.19.092Zm-6.11-2.638A3.7,3.7,0,0,1,7.9,9.346,6.6,6.6,0,0,1,6.358,7.469c-.269-.428-.415-.655-.545-.719a2.675,2.675,0,0,0-2.1-.194,3.007,3.007,0,0,1-.315.071,4.553,4.553,0,0,0-.692.176,1.833,1.833,0,0,1-.622.125A.374.374,0,0,1,1.8,6.593a.5.5,0,0,1,.31-.568,7.284,7.284,0,0,1,2.1-.7,5.378,5.378,0,0,1,1.5.046l.359.074L5.8,5.21a3.517,3.517,0,0,0-1.267-.664,4.274,4.274,0,0,0-1.575-.051,7.948,7.948,0,0,1-1.793.589c-.008,0-.86.084-.958-.5s.984-.9.994-.9l.036-.02A4.293,4.293,0,0,1,4.964,2.6l.277.077-.9-1.2L4.3,1.466C3.9,1.4,2.719,1.184,2.7,1.184A1.425,1.425,0,0,1,1.861.939.367.367,0,0,1,1.706.551a.365.365,0,0,1,.3-.287A5.855,5.855,0,0,1,5.52.8,42.994,42.994,0,0,1,8.783,4.05l.364.389c.763.8,2.74,2.371,2.76,2.387l.026.02.911.025c2.056,1.047,3.232,4.482,3.5,5.362-.7-.335-3.073-1.477-4.133-1.943a4.98,4.98,0,0,0-1.71-.54Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.887,1.2A5.354,5.354,0,0,0,2.61.2C1.011.437.044.608.034.61L0,.413C.01.411.978.239,2.581,0A5.473,5.473,0,0,1,6,1.041Z",
    transform: "translate(4.952 16.316)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.221,1.215A5.934,5.934,0,0,0,1.534.394,4.781,4.781,0,0,0,.018.2L0,0A4.93,4.93,0,0,1,1.585.2a6.024,6.024,0,0,1,1.755.851Z",
    transform: "translate(7.805 15.585)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 63.14)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.542,
    height: 4.796,
    transform: "translate(7.552 0.774)",
    fill: "#090a0a"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.542,
    height: 5.711,
    transform: "translate(40.293 2.076) rotate(-45)",
    fill: "#090a0a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.872,301.71h72.937a.612.612,0,0,1,.612.612v9.668a.612.612,0,0,1-.612.612H250.872a.612.612,0,0,1-.612-.612v-9.668A.613.613,0,0,1,250.872,301.71Z",
    transform: "translate(-250.26 -277.793)",
    fill: "#090a0a"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.958,
    height: 19.117,
    transform: "translate(27 3.55)",
    fill: "#090a0a"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.958,
    height: 19.117,
    transform: "translate(24.626 3.55)",
    fill: "#090a0a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.754,203.6h-1.542V187.385h-6.3a2.938,2.938,0,0,0-2.935,2.935V203.6H263.43V190.319a4.485,4.485,0,0,1,4.479-4.479h7.849Z",
    transform: "translate(-261.269 -180.933)",
    fill: "#090a0a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.014,203.6h-1.542V187.385h-6.625A2.618,2.618,0,0,0,483.232,190v13.6H481.69V190a4.161,4.161,0,0,1,4.157-4.157h8.167Z",
    transform: "translate(-443.721 -180.933)",
    fill: "#090a0a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.621,173.491a8.781,8.781,0,1,0-8.781-8.781,8.78,8.78,0,0,0,8.781,8.781Zm0-16.016a7.237,7.237,0,1,1-7.237,7.237,7.237,7.237,0,0,1,7.237-7.237Z",
    transform: "translate(-339.354 -155.93)",
    fill: "#090a0a"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.958,
    height: 15.192,
    transform: "translate(60.04 6.307)",
    fill: "#090a0a"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.958,
    height: 15.192,
    transform: "translate(62.349 6.336)",
    fill: "#090a0a"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.06,
    height: 1.542,
    transform: "translate(70.417 9.634)",
    fill: "#090a0a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.136,196.6a7.913,7.913,0,1,0-.007,0Zm-.005-17.625a8.042,8.042,0,1,1-8.042,8.042,8.043,8.043,0,0,1,8.042-8.042Z",
    transform: "translate(-515.494 -173.903)",
    fill: "#090a0a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.761,316.868a1.878,1.878,0,0,1-1.155.354,2.016,2.016,0,0,1-1.518-.635,2.79,2.79,0,0,1-.678-1.831h5.412c0-.146.007-.254.007-.328a3.935,3.935,0,0,0-.922-2.787,3.1,3.1,0,0,0-2.377-.991,3.19,3.19,0,0,0-2.446,1.011,4.017,4.017,0,0,0-.943,2.843,3.833,3.833,0,0,0,.932,2.751,3.774,3.774,0,0,0,4.6.366,3.1,3.1,0,0,0,1.114-1.729l-1.271-.156A2.344,2.344,0,0,1,321.761,316.868Zm-3.28-3.125a2.249,2.249,0,0,1,.635-1.516,1.952,1.952,0,0,1,1.426-.568,1.89,1.89,0,0,1,1.524.71,2.45,2.45,0,0,1,.466,1.373h-4.051Z",
    transform: "translate(-306.162 -285.264)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.25,315.883l1.216-.192a1.7,1.7,0,0,0,.571,1.121,1.984,1.984,0,0,0,1.309.389,1.926,1.926,0,0,0,1.257-.345,1.028,1.028,0,0,0,.41-.809.749.749,0,0,0-.363-.656,5.309,5.309,0,0,0-1.257-.417,11.356,11.356,0,0,1-1.875-.591,1.788,1.788,0,0,1-1.063-1.664,1.871,1.871,0,0,1,.221-.9,2,2,0,0,1,.605-.687,2.513,2.513,0,0,1,.783-.359,3.743,3.743,0,0,1,1.061-.148,4.207,4.207,0,0,1,1.5.246,2.035,2.035,0,0,1,.953.666,2.6,2.6,0,0,1,.423,1.124l-1.2.162a1.318,1.318,0,0,0-.474-.874,1.737,1.737,0,0,0-1.111-.31,2.014,2.014,0,0,0-1.209.281.821.821,0,0,0-.363.656.674.674,0,0,0,.151.43,1.091,1.091,0,0,0,.471.328q.185.069,1.088.312a15.42,15.42,0,0,1,1.821.571,1.853,1.853,0,0,1,.81.646,1.8,1.8,0,0,1,.294,1.052,2.079,2.079,0,0,1-.358,1.158,2.316,2.316,0,0,1-1.035.84,3.772,3.772,0,0,1-1.531.3,3.4,3.4,0,0,1-2.156-.587,2.739,2.739,0,0,1-.948-1.741Z",
    transform: "translate(-475.955 -285.245)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.73,315.883l1.216-.192a1.7,1.7,0,0,0,.571,1.121,1.984,1.984,0,0,0,1.309.389,1.926,1.926,0,0,0,1.257-.345,1.033,1.033,0,0,0,.41-.809.749.749,0,0,0-.363-.656,5.382,5.382,0,0,0-1.257-.417,11.358,11.358,0,0,1-1.875-.591,1.788,1.788,0,0,1-1.063-1.664,1.871,1.871,0,0,1,.221-.9,2,2,0,0,1,.605-.687,2.512,2.512,0,0,1,.783-.359,3.743,3.743,0,0,1,1.061-.148,4.206,4.206,0,0,1,1.5.246,2.035,2.035,0,0,1,.953.666,2.6,2.6,0,0,1,.423,1.124l-1.2.162a1.318,1.318,0,0,0-.474-.874,1.737,1.737,0,0,0-1.111-.31,2.014,2.014,0,0,0-1.209.281.821.821,0,0,0-.363.656.674.674,0,0,0,.151.43,1.091,1.091,0,0,0,.471.328q.185.069,1.088.312a15.413,15.413,0,0,1,1.821.571,1.849,1.849,0,0,1,.81.645,1.8,1.8,0,0,1,.294,1.052,2.08,2.08,0,0,1-.358,1.158,2.316,2.316,0,0,1-1.035.84,3.773,3.773,0,0,1-1.531.3,3.4,3.4,0,0,1-2.156-.587,2.717,2.717,0,0,1-.948-1.739Z",
    transform: "translate(-255.668 -285.245)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.7,316.868a1.881,1.881,0,0,1-1.155.354,2.016,2.016,0,0,1-1.516-.635,2.791,2.791,0,0,1-.678-1.831h5.413c0-.146.006-.254.006-.328a3.936,3.936,0,0,0-.922-2.787,3.1,3.1,0,0,0-2.377-.991,3.19,3.19,0,0,0-2.446,1.011,4.017,4.017,0,0,0-.943,2.843,3.833,3.833,0,0,0,.932,2.751,3.774,3.774,0,0,0,4.6.366,3.1,3.1,0,0,0,1.114-1.729l-1.272-.156A2.359,2.359,0,0,1,583.7,316.868Zm-3.28-3.125a2.249,2.249,0,0,1,.635-1.516,1.951,1.951,0,0,1,1.424-.568,1.89,1.89,0,0,1,1.524.71,2.451,2.451,0,0,1,.466,1.375h-4.052Z",
    transform: "translate(-525.127 -285.264)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.205,309.8h.041a.143.143,0,0,1-.028,0C395.2,309.8,395.2,309.8,395.205,309.8Z",
    transform: "translate(-371.423 -284.555)",
    fill: "#6a101a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.8,327.072V325.76l1.14.658,1.142.658-1.142.658-1.14.658Z",
    transform: "translate(-437.125 -297.897)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.219,314.08h0a3.69,3.69,0,1,0-3.69,3.69A3.69,3.69,0,0,0,463.219,314.08Zm-3.69-2.73a2.732,2.732,0,1,1-2.732,2.732,2.732,2.732,0,0,1,2.732-2.732Z",
    transform: "translate(-422.112 -285.049)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.025,
    height: 7.421,
    transform: "translate(40.315 25.321)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.867 25.537)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M307.02,186.332l-1.244,4.2-.417,1.4L305,190.54l-1.088-4.21h-1.1l1.9,7.258h1.234l2.269-7.258Z",
    transform: "translate(-298.259 -186.322)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.7,193.545h-.827l-1.906-7.265.825.007Z",
    transform: "translate(-292.541 -186.28)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.86,188.53l-.558,2.051q-.349,1.381-.376,1.5l-.43-1.559-1.155-4.189H275.07l2.221,7.257h1.285l.807-3.066Z",
    transform: "translate(-275.07 -186.322)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(63.426 25.537)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M357.593,186.323l-1.244,4.2-.417,1.4-.363-1.386-1.088-4.21h-1.1l1.906,7.257h1.234l2.269-7.258Z",
    transform: "translate(-348.834 -186.313)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.29,193.545h-.824l-1.906-7.265.825.007Z",
    transform: "translate(-343.133 -186.28)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.461,188.53l-.558,2.051q-.35,1.381-.376,1.5l-.43-1.559-1.155-4.189H325.67l2.221,7.257h1.285l.807-3.066Z",
    transform: "translate(-325.67 -186.322)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.216 102.906)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M285.928,762.573l-1.173-2.4-.328,2.4H282.05l1.171-8.562h1.731a5.192,5.192,0,0,1,1.91.251,2.546,2.546,0,0,1,1.145.9,2.415,2.415,0,0,1,.4,1.376,2.526,2.526,0,0,1-.581,1.66,2.685,2.685,0,0,1-1.122.778l1.749,3.6h-2.523Zm-.742-5.532a1.666,1.666,0,0,0,.712-.143.332.332,0,0,0,.144-.32.249.249,0,0,0-.043-.166.261.261,0,0,0-.159-.087,2.692,2.692,0,0,0-.55-.051Z",
    transform: "translate(-282.05 -748.845)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.345,756.85h1.322a4.845,4.845,0,0,1,1.726.213,2.071,2.071,0,0,1,.942.733,1.936,1.936,0,0,1,.317,1.112,2.055,2.055,0,0,1-.472,1.36,2.5,2.5,0,0,1-1.422.789l1.66,3.419h-1.483l-1.627-3.329h-.117l-.456,3.329H285.3Zm1.019,3.05a3.137,3.137,0,0,0,1.513-.241.8.8,0,0,0,.351-.707.715.715,0,0,0-.139-.451.742.742,0,0,0-.409-.253,5.1,5.1,0,0,0-1.078-.072Z",
    transform: "translate(-284.767 -751.219)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.23,762.564,323.4,754h5.043l-.3,2.29H325.48l-.09.64h2.671l-.3,2.279h-2.692l-.151,1.086h2.7l-.294,2.269Z",
    transform: "translate(-315.638 -748.837)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.532,756.85h4.1l-.177,1.353H327.8l-.22,1.577h2.676l-.174,1.342h-2.687l-.282,2.023h2.705l-.172,1.332H325.49Z",
    transform: "translate(-318.363 -751.219)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.209,762.564l-.764-4.018-1.895,4.018h-1.972L361.8,754h2.249l.328,3.652L366.1,754h1.762l.658,3.486L369.75,754h2.377l-3.032,8.564Z",
    transform: "translate(-348.716 -748.837)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.93,756.85h1.309l.443,4.942,2.331-4.942h1.078l.907,4.812,1.7-4.812h1.385l-2.7,7.627h-1.17l-.961-5.05-2.382,5.05h-1.247Z",
    transform: "translate(-351.332 -751.219)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.178,762.573l-1.173-2.4-.328,2.4H466.3l1.171-8.562H469.2a5.192,5.192,0,0,1,1.91.251,2.547,2.547,0,0,1,1.145.9,2.415,2.415,0,0,1,.4,1.376,2.525,2.525,0,0,1-.581,1.66,2.684,2.684,0,0,1-1.122.778l1.749,3.6h-2.523Zm-.742-5.532a1.666,1.666,0,0,0,.712-.143.332.332,0,0,0,.144-.32.262.262,0,0,0-.041-.166.268.268,0,0,0-.159-.089,2.7,2.7,0,0,0-.55-.051Z",
    transform: "translate(-436.071 -748.845)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.6,756.85h1.322a4.845,4.845,0,0,1,1.726.213,2.071,2.071,0,0,1,.942.733,1.935,1.935,0,0,1,.317,1.112,2.055,2.055,0,0,1-.473,1.36,2.5,2.5,0,0,1-1.422.789l1.66,3.419h-1.483l-1.628-3.329h-.116l-.456,3.329H469.55Zm1.019,3.05a3.137,3.137,0,0,0,1.513-.241.8.8,0,0,0,.351-.707.715.715,0,0,0-.139-.451.742.742,0,0,0-.409-.253,5.1,5.1,0,0,0-1.078-.072Z",
    transform: "translate(-438.788 -751.219)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.63,762.573l1.171-8.562h1.616a6.434,6.434,0,0,1,2.733.449,3.648,3.648,0,0,1,1.544,1.442,4.248,4.248,0,0,1,.586,2.228,4.671,4.671,0,0,1-.615,2.356,3.943,3.943,0,0,1-1.58,1.591,5.44,5.44,0,0,1-2.55.5H506.63Zm2.7-2.269a4.216,4.216,0,0,0,1.345-.152,1.764,1.764,0,0,0,.873-.707,2.317,2.317,0,0,0,.338-1.291,2.089,2.089,0,0,0-.231-1.039,1.511,1.511,0,0,0-.633-.6,2.559,2.559,0,0,0-1.147-.225Z",
    transform: "translate(-469.785 -748.845)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.943,756.85h1.209a6.083,6.083,0,0,1,2.53.4,3.19,3.19,0,0,1,1.349,1.262,3.767,3.767,0,0,1,.518,1.985,4.2,4.2,0,0,1-.553,2.123,3.491,3.491,0,0,1-1.391,1.411,5.058,5.058,0,0,1-2.331.443H509.9Zm1.257,1.344-.673,4.951H512a4.884,4.884,0,0,0,1.575-.182,2.24,2.24,0,0,0,1.1-.886,2.759,2.759,0,0,0,.415-1.55,2.558,2.558,0,0,0-.29-1.268,1.986,1.986,0,0,0-.824-.787,3.053,3.053,0,0,0-1.413-.277Z",
    transform: "translate(-472.518 -751.219)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.58,762.564,552.75,754H555.1l-1.2,8.564Z",
    transform: "translate(-507.36 -748.837)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.883,756.85h1.4l-1.068,7.627H554.84Z",
    transform: "translate(-510.085 -751.219)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.665,762.564l-2.241-4.212-.574,4.212h-2.32L569.69,754h1.939l2.2,4.152L574.4,754h2.339l-1.163,8.564Z",
    transform: "translate(-521.529 -748.837)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.832,756.85h1.25l2.751,5.186.709-5.186h1.4l-1.037,7.627h-1.222l-2.787-5.242-.715,5.242H571.8Z",
    transform: "translate(-524.263 -751.219)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.583,761.776a4.042,4.042,0,0,1-3.28-1.455,4.2,4.2,0,0,1-.963-2.756,4.591,4.591,0,0,1,1.388-3.332,4.52,4.52,0,0,1,3.316-1.4,4.767,4.767,0,0,1,1.391.207,4.54,4.54,0,0,1,1.232.586,4.946,4.946,0,0,1,1.045,1l.323.4L624.07,756.3l-.267-.3a2.859,2.859,0,0,0-.851-.709,2.045,2.045,0,0,0-.892-.184,2.138,2.138,0,0,0-1.782.883,2.5,2.5,0,0,0-.561,1.59,1.878,1.878,0,0,0,.543,1.38,1.779,1.779,0,0,0,1.332.55,2.117,2.117,0,0,0,1.1-.292,1.885,1.885,0,0,0,.276-.2h-1.962l.3-2.29h4.756l-.021.489a4.837,4.837,0,0,1-1.321,3.314A4.249,4.249,0,0,1,621.583,761.776Z",
    transform: "translate(-562.331 -747.859)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.722,757.331l-1.193.774a3.3,3.3,0,0,0-1-.822,2.5,2.5,0,0,0-1.094-.23,2.6,2.6,0,0,0-2.151,1.063,2.978,2.978,0,0,0-.661,1.877,2.346,2.346,0,0,0,.676,1.706,2.249,2.249,0,0,0,1.667.691,2.607,2.607,0,0,0,1.342-.356,2.675,2.675,0,0,0,.988-1.07h-2.38l.177-1.353h3.857a4.365,4.365,0,0,1-1.186,3.006,3.778,3.778,0,0,1-2.807,1.112,3.582,3.582,0,0,1-2.919-1.285,3.724,3.724,0,0,1-.855-2.458,4.121,4.121,0,0,1,1.252-3,4.053,4.053,0,0,1,2.983-1.265,4.253,4.253,0,0,1,1.253.187,4.022,4.022,0,0,1,1.106.525A4.207,4.207,0,0,1,627.722,757.331Z",
    transform: "translate(-564.705 -750.275)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.053,722.794l.226,1.537.458,3.109,3.306.118,1.836.066-1.4,1.211c-1.25,1.078-2.54,2.11-3.811,3.165l-.747,3.933-.169.889-.779-.435-2.628-1.468q-3.48,2.065-6.961,4.131a21.757,21.757,0,0,1,4.636-4.193c.673-.451,2.266-1.368,2.266-1.368l.33.176,2.18,1.161.563-3.321.041-.241.2-.166q1.289-1.1,2.577-2.2l-2.052-.115-.576-.033-.07-.559-.274-2.161-2.223,2.83-.123.157-.184.052a24.962,24.962,0,0,1-6.686.914h-.074l6.234-2,2.989-3.967.924-1.227m.067-.264-.151.2-.929,1.23-2.97,3.939-2.93.938-3.271,1.048-.633.2.664,0h.074a25.016,25.016,0,0,0,6.715-.917l.184-.052.033-.01.021-.026.123-.158,2.069-2.633.243,1.911.071.559.011.087.087,0,.576.033,1.792.1c-.719.614-1.544,1.318-2.377,2.026l-.2.166-.03.025-.007.038-.041.241-.538,3.176-2.052-1.093-.33-.176-.051-.028-.051.03c-.016.01-1.6.925-2.271,1.373a21.856,21.856,0,0,0-4.659,4.213l-.387.468.522-.31,3.58-2.125,3.329-1.977,2.576,1.439.779.435.126.071.028-.143.169-.889.74-3.9c.4-.331.807-.666,1.2-.989.851-.7,1.732-1.421,2.581-2.152l1.4-1.211.2-.176-.267-.01-1.836-.066-3.217-.115-.445-3.022-.226-1.537-.038-.244Z",
    transform: "translate(-373.886 -722.53)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.535,739.685a21.79,21.79,0,0,1,4.648-4.2c.666-.446,2.253-1.362,2.269-1.37l.025-.015,2.471,1.316.594-3.509.208-.177q1.24-1.053,2.477-2.111l-2.541-.141-.335-2.638-2.28,2.9-.2.056a24.988,24.988,0,0,1-6.7.915l-.407,0,6.535-2.093,3.983-5.284.7,4.727,5.232.187-1.5,1.3c-.848.732-1.729,1.454-2.581,2.152q-.61.5-1.217,1l-.927,4.876-3.445-1.924-7.2,4.27Z",
    transform: "translate(-375.081 -723.199)",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.561 14.592)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 2.71)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.387,
    height: 6.932,
    transform: "translate(-0.006 -0.002)",
    fill: "url(#c)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.988 3.674)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.086,
    height: 5.901,
    transform: "translate(-0.006 -0.004)",
    fill: "url(#e)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.354 3.619)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.371,
    height: 6.085,
    transform: "translate(-0.006 0.002)",
    fill: "url(#g)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.989 3.626)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.728,
    height: 6.08,
    transform: "translate(-0.003)",
    fill: "url(#i)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.861 2.574)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#j)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2.699,
    height: 7.015,
    transform: "translate(-0.005 -0.002)",
    fill: "url(#k)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.21 3.746)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#l)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.765,
    height: 5.829,
    transform: "translate(-0.002 -0.003)",
    fill: "url(#m)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.723 4.257)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#n)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.938,
    height: 5.317,
    transform: "translate(0.002)",
    fill: "url(#o)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.221 3.791)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.806,
    height: 5.782,
    transform: "translate(-0.002 -0.002)",
    fill: "url(#q)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.477 2.572)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2.715,
    height: 7.001,
    transform: "translate(-0.005 -0.001)",
    fill: "url(#s)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(38.325 3.675)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#t)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.081,
    height: 7.698,
    transform: "translate(0 -0.002)",
    fill: "url(#u)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.914)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#v)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.554,
    height: 3.48,
    transform: "translate(-0.048)",
    fill: "url(#w)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M570.726,815.82a.385.385,0,1,1-.386.386.385.385,0,0,1,.386-.386",
    transform: "translate(-542.603 -815.106)",
    fill: "#f15b2d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.865,814.63a.385.385,0,1,1-.386.385.385.385,0,0,1,.386-.385",
    transform: "translate(-576.993 -814.112)",
    fill: "#f15b2d"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1684.938 1848.955)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1,92.525-.525,0",
    transform: "translate(1 0)",
    fill: "none",
    stroke: "#717171",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1666.222 1831.455)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.726,1761.332a.561.561,0,0,0,.049-.07c.437-.886.906-1.759,1.3-2.663q2.313-5.262,4.587-10.542.425-.981.809-1.98a.776.776,0,0,0-.168-.812.805.805,0,0,0-.848.2,2.611,2.611,0,0,0-.353.432c-.151.239-.284.491-.413.743a23.646,23.646,0,0,1-5.594,7.228,6.7,6.7,0,0,1-2.587,1.5,10.2,10.2,0,0,1-6.446-.378,3.926,3.926,0,0,1-2.581-2.943,8.525,8.525,0,0,1-.21-1.636c-.034-1.322-.023-2.644-.024-3.967,0-1.469.005-2.938.007-4.407,0-.348.018-.7-.006-1.046a1.053,1.053,0,0,0-1.044-1.019,1.04,1.04,0,0,0-1.1.927,2.746,2.746,0,0,0-.035.436c0,2.572,0,5.145,0,7.718,0,.713,0,1.43-.061,2.139a4.181,4.181,0,0,1-2.48,3.655,9.541,9.541,0,0,1-5.266.8,6.5,6.5,0,0,1-3.792-1.588c-.666-.605-1.333-1.213-1.952-1.865a24.341,24.341,0,0,1-4.005-5.807,5.269,5.269,0,0,0-.724-1,.635.635,0,0,0-.679-.154c-.217.063-.215.28-.261.458a1.344,1.344,0,0,0,.173.887q3.1,7.359,6.19,14.718c.036.086.08.168.126.263.1-.06.171-.106.246-.154a29.4,29.4,0,0,1,6.448-3.153,21.716,21.716,0,0,1,10.146-.983,25.22,25.22,0,0,1,8.278,2.782C176.22,1760.456,176.963,1760.9,177.726,1761.332Zm-24.505-7.442c.695.2,1.329.433,1.984.561a6.257,6.257,0,0,0,4.432-.615,3.857,3.857,0,0,0,1.638-1.48c.338-.636.313-.728-.356-.994a4.321,4.321,0,0,1-1.408-.8,20.354,20.354,0,0,1-5.164-7.714,1.937,1.937,0,0,0-.254-.493.568.568,0,0,0-.6-.238.505.505,0,0,0-.267.572,7.373,7.373,0,0,0,.276,1.353,18.567,18.567,0,0,1,1.018,3.845,9,9,0,0,1-.224,3.855A7.613,7.613,0,0,1,153.22,1753.889Zm21.865-.085c-.216-.332-.441-.631-.62-.956a6.95,6.95,0,0,1-.724-3.049,13.3,13.3,0,0,1,.8-4.962c.236-.7.435-1.423.625-2.141a.456.456,0,0,0-.275-.582.5.5,0,0,0-.653.222,3.737,3.737,0,0,0-.294.612,21.95,21.95,0,0,1-4.279,6.9,5.1,5.1,0,0,1-2.358,1.607c-.5.144-.584.423-.325.872a3.636,3.636,0,0,0,1.076,1.11,6.377,6.377,0,0,0,4.161,1.141A7.024,7.024,0,0,0,175.085,1753.8Zm-20.966-14.667a1.583,1.583,0,0,0-1.613-1.6,1.614,1.614,0,0,0-1.611,1.61,1.633,1.633,0,0,0,1.624,1.6A1.607,1.607,0,0,0,154.12,1739.138Zm23.321,0a1.611,1.611,0,0,0-3.222.015,1.611,1.611,0,0,0,3.222-.015Z",
    transform: "translate(-139.878 -1733.294)",
    fill: "#ffc905"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.085,1730.929a8.056,8.056,0,0,1,1.1.352,3.025,3.025,0,0,1,1.624,3.351,3.1,3.1,0,0,1-6.124-.584,3.071,3.071,0,0,1,2.588-3.069,1.66,1.66,0,0,0,.179-.049Z",
    transform: "translate(-149.487 -1730.929)",
    fill: "#ffc905"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.682,1743.356c.034-.155.066-.311.1-.466a2.5,2.5,0,0,1,2.512-1.863,2.514,2.514,0,1,1-2.574,2.826.469.469,0,0,0-.041-.107Z",
    transform: "translate(-137.682 -1734.54)",
    fill: "#ffc905"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.521,1743.946c-.035.114-.069.227-.1.342a2.49,2.49,0,0,1-4.873-.809,2.489,2.489,0,0,1,4.928-.443.9.9,0,0,0,.049.132Z",
    transform: "translate(-161.958 -1734.546)",
    fill: "#ffc905"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.726,1762.683c-.762-.431-1.506-.876-2.27-1.281a25.22,25.22,0,0,0-8.278-2.782,21.716,21.716,0,0,0-10.146.984,29.388,29.388,0,0,0-6.448,3.153l-.246.154c-.046-.095-.09-.177-.126-.263q-3.1-7.359-6.19-14.718a1.345,1.345,0,0,1-.173-.888c.046-.178.044-.4.261-.458a.635.635,0,0,1,.679.154,5.263,5.263,0,0,1,.724,1,24.357,24.357,0,0,0,4.005,5.807c.62.652,1.286,1.259,1.952,1.865a6.5,6.5,0,0,0,3.792,1.588,9.542,9.542,0,0,0,5.266-.8,4.181,4.181,0,0,0,2.48-3.655c.062-.709.059-1.426.061-2.139.006-2.572,0-5.145,0-7.718a2.74,2.74,0,0,1,.035-.435,1.04,1.04,0,0,1,1.1-.927,1.053,1.053,0,0,1,1.044,1.019c.024.348.007.7.006,1.046,0,1.469-.008,2.938-.007,4.407,0,1.322-.01,2.645.024,3.967a8.522,8.522,0,0,0,.21,1.636,3.927,3.927,0,0,0,2.581,2.943,10.206,10.206,0,0,0,6.446.379,6.706,6.706,0,0,0,2.587-1.5,23.643,23.643,0,0,0,5.594-7.228c.129-.252.262-.5.413-.743a2.611,2.611,0,0,1,.353-.432.8.8,0,0,1,.848-.2.776.776,0,0,1,.168.812q-.385,1-.809,1.979-2.286,5.275-4.587,10.542c-.4.9-.867,1.777-1.3,2.663A.561.561,0,0,1,177.726,1762.683Z",
    transform: "translate(-139.878 -1734.646)",
    fill: "#ffc905"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.454,1756.43a7.607,7.607,0,0,0,1.075-2.145,9,9,0,0,0,.224-3.855,18.569,18.569,0,0,0-1.018-3.845,7.369,7.369,0,0,1-.276-1.353.5.5,0,0,1,.267-.572.569.569,0,0,1,.6.238,1.939,1.939,0,0,1,.254.493,20.35,20.35,0,0,0,5.165,7.714,4.324,4.324,0,0,0,1.408.8c.669.266.694.358.356.994a3.858,3.858,0,0,1-1.638,1.48,6.26,6.26,0,0,1-4.432.615C159.782,1756.863,159.149,1756.631,158.454,1756.43Z",
    transform: "translate(-145.112 -1735.835)",
    fill: "#ffc905"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.906,1756.328a7.024,7.024,0,0,1-2.864.778,6.376,6.376,0,0,1-4.161-1.141,3.636,3.636,0,0,1-1.076-1.11c-.259-.449-.175-.729.325-.872a5.093,5.093,0,0,0,2.358-1.607,21.951,21.951,0,0,0,4.279-6.9,3.741,3.741,0,0,1,.294-.612.5.5,0,0,1,.653-.222.456.456,0,0,1,.275.581c-.189.719-.389,1.437-.625,2.141a13.3,13.3,0,0,0-.8,4.962,6.947,6.947,0,0,0,.724,3.049C187.466,1755.7,187.69,1756,187.906,1756.328Z",
    transform: "translate(-152.699 -1735.818)",
    fill: "#ffc905"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.059,1739.138a1.607,1.607,0,0,1-1.6,1.615,1.633,1.633,0,0,1-1.624-1.6,1.614,1.614,0,0,1,1.611-1.61A1.583,1.583,0,0,1,158.059,1739.138Z",
    transform: "translate(-143.818 -1733.294)",
    fill: "#ffc905"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.371,1739.138a1.611,1.611,0,0,1-3.222.015,1.611,1.611,0,0,1,3.222-.015Z",
    transform: "translate(-156.809 -1733.294)",
    fill: "#ffc905"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.275,
    height: 7.047,
    transform: "translate(70.751 66.766) rotate(-89.541)",
    fill: "#ffc905"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.275,
    height: 7.047,
    transform: "translate(117.679 67.141) rotate(-89.541)",
    fill: "#ffc905"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.3,1862.944l-.019,2.3,7.224.057.03-.168a7.71,7.71,0,0,0,.121-1.3,5.987,5.987,0,0,0-.036-.635l-.019-.18Z",
    transform: "translate(-182.613 -1778.154)",
    fill: "#ffc905"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.464 26.339)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.084,1796.157a.271.271,0,0,1,.017-.052l.023-.069.03-3.327c-.006-.032-.015-.066-.024-.1a.354.354,0,0,1-.015-.07,5.858,5.858,0,0,0-.108-1.138c-.019-.119-.038-.239-.055-.359a23.264,23.264,0,0,0-1.4-5.351,22.135,22.135,0,0,0-4.582-7.257,20.547,20.547,0,0,0-5.687-4.252,20.8,20.8,0,0,0-5.371-1.806,24.09,24.09,0,0,0-5.2-.43,21.6,21.6,0,0,0-8.619,2.01,20.709,20.709,0,0,0-3.651,2.2,22.6,22.6,0,0,0-8.366,13.275,24.1,24.1,0,0,0-.522,4.123l-.023.1c0,.341,0,.682-.008,1.025l.021.089a22.138,22.138,0,0,0,.3,3.257,19.556,19.556,0,0,0,2.371,6.574,25.062,25.062,0,0,0,5.108,6.145,40.3,40.3,0,0,0,5.547,4.117,73.618,73.618,0,0,0,8.137,4.348c2.815,1.308,5.69,2.505,8.376,3.6l.8.325q1.351.547,2.7,1.1a.95.95,0,0,0,.356.073.837.837,0,0,0,.776-.545.939.939,0,0,0,.089-.325l.006-.165a3.568,3.568,0,0,0-.017-.7,6.988,6.988,0,0,0-.465-1.591,7.524,7.524,0,0,0-.608-1.182,5.8,5.8,0,0,0-2.062-2.114l-.771-.435c-.759-.43-1.543-.875-2.339-1.277-1.642-.827-3.32-1.65-4.943-2.446q-1.286-.632-2.572-1.265l-.063-.031c-1.547-.765-3.148-1.557-4.64-2.474a28.4,28.4,0,0,1-5.923-4.642,19.429,19.429,0,0,1-3.365-4.862,15.865,15.865,0,0,1-1.572-5.851,14.265,14.265,0,0,1,.342-4.276,14.973,14.973,0,0,1,2.347-5.122,16.217,16.217,0,0,1,1.953-2.3,15.518,15.518,0,0,1,2.256-1.754l.127-.086a16.143,16.143,0,0,1,2.215-1.338,17.986,17.986,0,0,1,7.493-1.687,18.337,18.337,0,0,1,2.577.167,15.906,15.906,0,0,1,5.1,1.51,13.059,13.059,0,0,1,4,3.04,14.312,14.312,0,0,1,2.748,4.694,19.648,19.648,0,0,1,1.087,8.408,11.913,11.913,0,0,1-.726,3.23,7.474,7.474,0,0,1-2.409,3.365.718.718,0,0,0-.26.484,2.692,2.692,0,0,0,.119,1.165,15.514,15.514,0,0,0,1.893,4.121,4.3,4.3,0,0,0,.36.469l.083.1a.359.359,0,0,0,.249.137.386.386,0,0,0,.286-.107,18.38,18.38,0,0,0,3.518-3.942,19.086,19.086,0,0,0,2.555-5.921A11.143,11.143,0,0,0,185.084,1796.157Z",
    transform: "translate(-141.518 -1771.938)",
    fill: "#1166af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.982,1855.58a4.1,4.1,0,0,0,.109-.522l.023-.132v-.024a6.377,6.377,0,0,0-.638-2.594,2.849,2.849,0,0,0-1.423-1.405l-.04-.017q-2.553-1.091-5.1-2.193l-3.761-1.623q-3.386-1.456-6.768-2.917l-1.721-.742a.926.926,0,0,0-1.355.46c-.01.018-.02.036-.039.076a3.8,3.8,0,0,0-.393,1.592,4.265,4.265,0,0,0,.245,1.778,1.651,1.651,0,0,0,1.011,1.017c.185.066.367.141.552.22q.918.38,1.843.761,2.492,1.024,4.987,2.053l10.276,4.234c.39.161.786.323,1.184.475a.956.956,0,0,0,.342.069.653.653,0,0,0,.294-.066A.751.751,0,0,0,182.982,1855.58Z",
    transform: "translate(-148.797 -1797.459)",
    fill: "#1166af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.057,1860.143q-2.353-.9-4.7-1.787l-4.453-1.691a.867.867,0,0,0-1.235.459.275.275,0,0,0-.041.087l-.078.226a3.328,3.328,0,0,0-.11,1.83,1.609,1.609,0,0,0,1.074,1.218q3.18,1.117,6.361,2.248l3.869,1.378a.873.873,0,0,0,.29.053.651.651,0,0,0,.317-.079.707.707,0,0,0,.339-.477,2.742,2.742,0,0,0,.057-.369l.017-.163a4.042,4.042,0,0,0-.613-2.019A2.1,2.1,0,0,0,178.057,1860.143Z",
    transform: "translate(-150.761 -1802.212)",
    fill: "#1166af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.689,1824.28h.039a4.3,4.3,0,0,1,3.3,1.389l.2.212,1.01-2.172-.106-.1a6.427,6.427,0,0,0-4.276-1.631h-.058a7,7,0,1,0-.053,14.005h.05a6.432,6.432,0,0,0,4.252-1.581l.108-.1-.978-2.191-.208.214a4.254,4.254,0,0,1-3.325,1.354,4.7,4.7,0,0,1,.037-9.4Z",
    transform: "translate(-166.262 -1789.839)",
    fill: "#1166af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.12,1831.418l1.77.014,3.265,4.613,2.712.022-3.447-4.882a4.4,4.4,0,0,0,3.012-4.358,4.178,4.178,0,0,0-1.274-3.228,5.765,5.765,0,0,0-3.953-1.267l-4.314-.034-.019,2.3,4.967.04a2.438,2.438,0,0,1,1.636.546,2.2,2.2,0,0,1,.654,1.741,2.115,2.115,0,0,1-2.366,2.211l-4.927-.039-.055,6.888,2.3.019Z",
    transform: "translate(-173.45 -1789.953)",
    fill: "#1166af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.782,1840.222l-8-.071-.018,2.309,8,.064Z",
    transform: "translate(-179.526 -1796.34)",
    fill: "#1166af"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.302,
    height: 7.996,
    transform: "translate(68.332 34.734) rotate(-89.541)",
    fill: "#1166af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.4,1826.855l2.745,6.179,1.321,2.976,2.5.02-6.529-14.336-6.757,14.229,2.5.02Z",
    transform: "translate(-184.148 -1789.737)",
    fill: "#1166af"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.269,
    height: 9.261,
    transform: "matrix(0.008, -1, 1, 0.008, 88.125, 34.859)",
    fill: "#1166af"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.742,
    height: 2.303,
    transform: "translate(91.512 46.306) rotate(-89.541)",
    fill: "#1166af"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13.689,
    height: 2.303,
    transform: "translate(98.602 46.363) rotate(-89.548)",
    fill: "#1166af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.043,1823l-2.5-.02-3.536,7.991,1.185,2.773Z",
    transform: "translate(-202.149 -1790.198)",
    fill: "#1166af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.155,1834.5l-4.931-11.621-2.5-.02,6.206,14.354Z",
    transform: "translate(-198.47 -1790.153)",
    fill: "#1166af"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.302,
    height: 7.996,
    transform: "translate(115.261 35.109) rotate(-89.544)",
    fill: "#1166af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.847,1840.806l-8-.07-.018,2.309,8,.064Z",
    transform: "translate(-205.664 -1796.549)",
    fill: "#1166af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.995,1859.876l6.087-6.657L214,1853.2l-4.81,5.472.044-5.51-2.3-.018-.109,13.688,2.3.018.044-5.534,5.041,5.575,3.077.025Z",
    transform: "translate(-164.881 -1800.986)",
    fill: "#1166af"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13.689,
    height: 2.303,
    transform: "translate(53.581 65.934) rotate(-89.538)",
    fill: "#1166af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.854,1861.305l-2.284-2.333-.081,10.073,2.3.019Z",
    transform: "translate(-174.061 -1803.073)",
    fill: "#1166af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.82,1853.076l-.07,8.8-9.1-9.483-.026,3.2,11.381,11.8.114-14.3Z",
    transform: "translate(-174.11 -1800.719)",
    fill: "#1166af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.89,1862.31l-2.378-.02-.052.128a4.17,4.17,0,0,1-4,2.635h-.041a4.7,4.7,0,0,1,.037-9.4h.038a4.2,4.2,0,0,1,3.757,2.294l.076.146,2.316-.649-.109-.219a6.65,6.65,0,0,0-6.021-3.875,7,7,0,1,0-.112,14h.057a6.564,6.564,0,0,0,6.358-4.787Z",
    transform: "translate(-181.559 -1801.062)",
    fill: "#1166af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.652,1860.621a6.512,6.512,0,0,0-6.928-6.9l-4.175-.034-.018,2.3,4.67.037a4,4,0,0,1,3,1.344,4.774,4.774,0,0,1,1.146,3.231,4.273,4.273,0,0,1-4.223,4.51l-4.67-.038-.018,2.3,4.175.033h.076C283.825,1867.409,286.619,1864.69,286.652,1860.621Z",
    transform: "translate(-189.425 -1801.182)",
    fill: "#1166af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.937,1860.631a7.032,7.032,0,0,0,6.389,7.03l.218.02.018-2.305-.181-.021a4.7,4.7,0,0,1,.075-9.344l.18-.017.019-2.3-.218.015A7.034,7.034,0,0,0,294.937,1860.631Z",
    transform: "translate(-196.4 -1801.183)",
    fill: "#1166af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313,1860.747a7.035,7.035,0,0,0-6.39-7.031l-.218-.018-.018,2.3.18.021a4.7,4.7,0,0,1-.075,9.343l-.18.018-.018,2.3.218-.016A7.033,7.033,0,0,0,313,1860.747Z",
    transform: "translate(-200.458 -1801.186)",
    fill: "#1166af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.431,1869.982l2.348.019,1.063-6.289-1.737-3.357Z",
    transform: "translate(-204.804 -1803.568)",
    fill: "#1166af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.979,1852.894l-.639,3.671,5.8,11.361,5.981-11.251-.582-3.7-5.361,10.193Z",
    transform: "translate(-205.845 -1800.899)",
    fill: "#1166af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.125,1870.106l2.348.019-1.53-9.714-1.782,3.374Z",
    transform: "translate(-211.505 -1803.588)",
    fill: "#1166af"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 67.31)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.151,1882.339l.58,0,.022-2.7.988.008,0-.58-.989-.008.008-.924,1.877.015,0-.58-2.458-.02Z",
    transform: "translate(-158.151 -1876.997)",
    fill: "#1166af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.616,1880.111h0a1.518,1.518,0,0,0,.3-.9,1.561,1.561,0,0,0-.209-.807,1.614,1.614,0,0,0-.576-.584,1.562,1.562,0,0,0-.8-.223l-1.279-.01-.038,4.781.58,0,.012-1.523.524,0a1.918,1.918,0,0,0,.411-.044l.787,1.576.651.006-.895-1.8A1.8,1.8,0,0,0,164.616,1880.111Zm-1.986-1.937.693.006a.937.937,0,0,1,.5.141,1.023,1.023,0,0,1,.365.379,1,1,0,0,1,.132.509.936.936,0,0,1-.161.533,1.127,1.127,0,0,1-.438.383,1.191,1.191,0,0,1-.585.138l-.518,0Z",
    transform: "translate(-159.368 -1877.007)",
    fill: "#1166af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.733,1877.9a2.172,2.172,0,0,0-1.161-.344h-.018a2.167,2.167,0,0,0-1.152.325,2.408,2.408,0,0,0-.847.89,2.566,2.566,0,0,0-.019,2.444,2.4,2.4,0,0,0,.832.9,2.169,2.169,0,0,0,1.166.344h.019a2.171,2.171,0,0,0,1.147-.324,2.381,2.381,0,0,0,.85-.891,2.569,2.569,0,0,0,.02-2.444A2.39,2.39,0,0,0,169.733,1877.9Zm-1.183,3.982h-.013a1.557,1.557,0,0,1-.856-.254,1.826,1.826,0,0,1-.629-.687,2,2,0,0,1,.012-1.887,1.792,1.792,0,0,1,.638-.677,1.586,1.586,0,0,1,.849-.24h.016a1.567,1.567,0,0,1,.855.253,1.85,1.85,0,0,1,.629.688,1.936,1.936,0,0,1,.23.945,1.967,1.967,0,0,1-.242.943,1.8,1.8,0,0,1-.639.676A1.579,1.579,0,0,1,168.55,1881.884Z",
    transform: "translate(-160.697 -1876.997)",
    fill: "#1166af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.291,1876.738l-.043,5.426.58,0,.027-3.277,1.5,2.625,1.552-2.6-.026,3.279.58,0,.043-5.423-2.14,3.588Z",
    transform: "translate(-162.906 -1876.738)",
    fill: "#1166af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182,1878.328l1.243.01-.034,4.2.581,0,.034-4.2,1.254.01.007-.58-3.08-.025Z",
    transform: "translate(-165.662 -1877.056)",
    fill: "#1166af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.079,1880.421l-1.762-.014.021-2.616-.58,0-.038,4.781.58,0,.013-1.572,1.762.014-.012,1.573.581,0,.038-4.782-.581,0Z",
    transform: "translate(-167.15 -1877.069)",
    fill: "#1166af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.356,1882.605l2.545.02,0-.581-1.963-.015.017-2.11,1.914.015,0-.581-1.914-.015.008-.93,1.964.016,0-.58-2.544-.02Z",
    transform: "translate(-168.61 -1877.08)",
    fill: "#1166af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.158,1882.26l0-.442-1.871-.015.034-4.2-.581,0-.038,4.782,2.409.019h0l.607,0,.249-.774,1.654.013.242.778.612,0-1.635-5.431Zm1.006-1.218.662-2.089.624,2.1Z",
    transform: "translate(-170.611 -1876.819)",
    fill: "#1166af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.883,1881.066l-2.578-4.011-.043,5.377.58,0,.027-3.408,2.584,4.01.043-5.35-.587-.005Z",
    transform: "translate(-173.306 -1876.838)",
    fill: "#1166af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.487,1878.325a2.376,2.376,0,0,0-1.21-.334l-.943-.008-.038,4.781.943.007h.023a2.428,2.428,0,0,0,1.2-.3,2.341,2.341,0,0,0,1.213-2.048,2.37,2.37,0,0,0-.314-1.208A2.4,2.4,0,0,0,213.487,1878.325Zm-1.576.243.355,0a1.8,1.8,0,0,1,.915.254,1.844,1.844,0,0,1,.663.674,1.771,1.771,0,0,1,.236.916,1.735,1.735,0,0,1-.25.9,1.779,1.779,0,0,1-.668.645,1.91,1.91,0,0,1-.925.232l-.356,0Z",
    transform: "translate(-174.892 -1877.131)",
    fill: "#1166af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.179,1878.321a2.173,2.173,0,0,0-1.16-.343,2.142,2.142,0,0,0-1.171.325,2.407,2.407,0,0,0-.846.89,2.569,2.569,0,0,0-.02,2.444,2.4,2.4,0,0,0,.832.9,2.18,2.18,0,0,0,1.166.343H221a2.169,2.169,0,0,0,1.149-.325,2.386,2.386,0,0,0,.849-.89,2.566,2.566,0,0,0,.02-2.445A2.394,2.394,0,0,0,222.179,1878.321ZM221,1882.3h-.014a1.57,1.57,0,0,1-.856-.253,1.848,1.848,0,0,1-.629-.688,2,2,0,0,1,.013-1.888,1.8,1.8,0,0,1,.638-.676,1.6,1.6,0,0,1,.849-.24h.014a1.561,1.561,0,0,1,.856.253,1.848,1.848,0,0,1,.63.688,2,2,0,0,1-.014,1.887h0a1.785,1.785,0,0,1-.639.677A1.594,1.594,0,0,1,221,1882.3Z",
    transform: "translate(-177.219 -1877.129)",
    fill: "#1166af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.694,1882.879l.581.005.021-2.7.989.008,0-.581-.987-.008.007-.924,1.878.015,0-.58-2.457-.02Z",
    transform: "translate(-179.427 -1877.167)",
    fill: "#1166af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.261,1878.425a2.174,2.174,0,0,0-1.161-.342,2.07,2.07,0,0,0-1.171.325,2.406,2.406,0,0,0-.845.89,2.564,2.564,0,0,0-.02,2.444,2.4,2.4,0,0,0,.832.9,2.163,2.163,0,0,0,1.165.344h.021a2.172,2.172,0,0,0,1.146-.324,2.393,2.393,0,0,0,.85-.89,2.566,2.566,0,0,0,.02-2.445A2.4,2.4,0,0,0,235.261,1878.425Zm-1.2,3.983a1.566,1.566,0,0,1-.857-.253,1.833,1.833,0,0,1-.628-.688,1.934,1.934,0,0,1-.23-.945,1.955,1.955,0,0,1,.242-.943,1.8,1.8,0,0,1,.639-.677,1.6,1.6,0,0,1,.849-.24h.014a1.587,1.587,0,0,1,.856.253,1.834,1.834,0,0,1,.629.688,2,2,0,0,1-.013,1.886h0a1.8,1.8,0,0,1-.638.676A1.608,1.608,0,0,1,234.065,1882.407Z",
    transform: "translate(-181.339 -1877.161)",
    fill: "#1166af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.375,1880.725a1.526,1.526,0,0,0,.3-.9,1.57,1.57,0,0,0-.21-.808,1.609,1.609,0,0,0-.575-.583,1.548,1.548,0,0,0-.8-.223l-1.279-.01-.038,4.781.581,0,.012-1.522.524,0a1.709,1.709,0,0,0,.41-.044l.788,1.576.652,0-.895-1.8A1.787,1.787,0,0,0,241.375,1880.725Zm-1.986-1.937.692.006a.945.945,0,0,1,.5.141,1.035,1.035,0,0,1,.365.379,1,1,0,0,1,.132.51.94.94,0,0,1-.161.532,1.129,1.129,0,0,1-.438.383,1.206,1.206,0,0,1-.585.138l-.518,0Z",
    transform: "translate(-183.548 -1877.2)",
    fill: "#1166af"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.782,
    height: 0.58,
    transform: "matrix(0.008, -1, 1, 0.008, 58.353, 5.81)",
    fill: "#1166af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.055,1879.008a1.553,1.553,0,0,1,.859-.243,1.649,1.649,0,0,1,.917.3l.177.119.333-.488-.183-.121a2.263,2.263,0,0,0-1.239-.386,2.317,2.317,0,0,0-1.171.325,2.4,2.4,0,0,0-.845.886,2.578,2.578,0,0,0-.02,2.451,2.4,2.4,0,0,0,.831.9,2.168,2.168,0,0,0,1.166.344h.02a2.209,2.209,0,0,0,1.217-.361l.12-.059.018-2.313-1.209-.01,0,.587.627.005-.011,1.381a1.594,1.594,0,0,1-.76.188h-.013a1.559,1.559,0,0,1-.855-.255,1.883,1.883,0,0,1-.631-.689,1.982,1.982,0,0,1,.015-1.88A1.88,1.88,0,0,1,246.055,1879.008Z",
    transform: "translate(-185.378 -1877.194)",
    fill: "#1166af"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.782,
    height: 0.58,
    transform: "matrix(0.008, -1, 1, 0.008, 63.169, 5.848)",
    fill: "#1166af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.217,1881.429l-2.579-4.01-.043,5.376.58,0,.027-3.409,2.585,4.011.043-5.35-.587,0Z",
    transform: "translate(-187.586 -1876.953)",
    fill: "#1166af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.938,1878.387l-3.078-.025,0,.581,1.243.01-.034,4.2.581,0,.034-4.2,1.256.01Z",
    transform: "translate(-186.562 -1877.25)",
    fill: "#1166af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.2,1878.673a2.176,2.176,0,0,0-1.161-.343,2.278,2.278,0,0,0-1.171.325,2.408,2.408,0,0,0-.846.889,2.573,2.573,0,0,0-.019,2.445,2.4,2.4,0,0,0,.832.9,2.17,2.17,0,0,0,1.165.344h.018a2.18,2.18,0,0,0,1.149-.324,2.4,2.4,0,0,0,.849-.89,2.566,2.566,0,0,0,.02-2.445A2.39,2.39,0,0,0,266.2,1878.673Zm-1.2,3.982a1.558,1.558,0,0,1-.856-.254,1.839,1.839,0,0,1-.629-.687,2.006,2.006,0,0,1,.013-1.888,1.807,1.807,0,0,1,.639-.676,1.6,1.6,0,0,1,.849-.24h.014a1.563,1.563,0,0,1,.856.253,1.843,1.843,0,0,1,.629.688,2,2,0,0,1-.013,1.888h0a1.792,1.792,0,0,1-.638.676A1.63,1.63,0,0,1,265,1882.656Z",
    transform: "translate(-187.773 -1877.24)",
    fill: "#1166af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.389,1879.227a1.565,1.565,0,0,1,.859-.242,1.649,1.649,0,0,1,.916.295l.178.12.332-.489-.183-.12a2.257,2.257,0,0,0-1.239-.386,2.2,2.2,0,0,0-1.171.325,2.406,2.406,0,0,0-.845.886,2.577,2.577,0,0,0-.021,2.452,2.422,2.422,0,0,0,.832.9,2.176,2.176,0,0,0,1.165.343h.018a2.167,2.167,0,0,0,1.2-.356l.181-.118-.322-.5-.182.123a1.5,1.5,0,0,1-.893.267,1.56,1.56,0,0,1-.856-.256,1.866,1.866,0,0,1-.63-.689,1.976,1.976,0,0,1,.015-1.879A1.87,1.87,0,0,1,273.389,1879.227Z",
    transform: "translate(-190.676 -1877.263)",
    fill: "#1166af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.2,1881.035a1.515,1.515,0,0,0,.3-.9,1.563,1.563,0,0,0-.21-.807,1.609,1.609,0,0,0-.575-.585,1.558,1.558,0,0,0-.8-.222l-1.279-.011-.038,4.782.58,0,.012-1.522.524.005a1.809,1.809,0,0,0,.41-.045l.787,1.576.652,0-.895-1.8A1.8,1.8,0,0,0,280.2,1881.035Zm-1.986-1.936.692.005a.938.938,0,0,1,.5.141,1.014,1.014,0,0,1,.364.379.988.988,0,0,1,.132.509.943.943,0,0,1-.162.533,1.118,1.118,0,0,1-.437.382,1.244,1.244,0,0,1-.586.139l-.518,0Z",
    transform: "translate(-192.465 -1877.297)",
    fill: "#1166af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.068,1883.331l2.544.02,0-.581-1.964-.016.017-2.11,1.914.015,0-.58-1.914-.016.008-.929,1.964.015,0-.58-2.544-.02Z",
    transform: "translate(-193.874 -1877.309)",
    fill: "#1166af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.992,1883.075l.607.005.249-.775,1.654.013.242.779.612,0-1.634-5.431Zm1.05-1.355.662-2.089.625,2.1Z",
    transform: "translate(-195.11 -1877.032)",
    fill: "#1166af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.892,1879.192l1.243.01-.034,4.2.581,0,.034-4.2,1.256.01,0-.58-3.078-.024Z",
    transform: "translate(-196.339 -1877.329)",
    fill: "#1166af"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.782,
    height: 0.581,
    transform: "matrix(0.008, -1, 1, 0.008, 96.851, 6.091)",
    fill: "#1166af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.51,1882.068l-1.038-3.4-.607,0,1.63,5.366,1.709-5.339-.607,0Z",
    transform: "translate(-198.22 -1877.344)",
    fill: "#1166af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.847,1883.481l2.544.02,0-.58-1.964-.016.017-2.11,1.915.015,0-.58-1.914-.015.008-.93,1.964.016,0-.58-2.544-.02Z",
    transform: "translate(-199.789 -1877.357)",
    fill: "#1166af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.442,1878.767l-1.643,2.248.018-2.261-.58,0-.038,4.782.58,0,.012-1.513.409-.558,1.178,2.084.672,0-1.476-2.607,1.584-2.173Z",
    transform: "translate(-201.79 -1877.372)",
    fill: "#1166af"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.782,
    height: 0.58,
    transform: "matrix(0.008, -1, 1, 0.008, 108.378, 6.183)",
    fill: "#1166af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.381,1881.918l-2.579-4.01-.043,5.377.58,0,.027-3.409,2.585,4.011.043-5.35-.587,0Z",
    transform: "translate(-203.542 -1877.107)",
    fill: "#1166af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.2,1879.593a1.593,1.593,0,0,1,.859-.242,1.653,1.653,0,0,1,.916.3l.178.119.332-.488-.183-.12a2.262,2.262,0,0,0-1.239-.386,2.107,2.107,0,0,0-1.171.325,2.414,2.414,0,0,0-.845.886,2.577,2.577,0,0,0-.019,2.452,2.412,2.412,0,0,0,.832.9,2.173,2.173,0,0,0,1.165.343h.019a2.214,2.214,0,0,0,1.218-.361l.118-.059.018-2.312-1.209-.01,0,.587.627.005-.012,1.381a1.651,1.651,0,0,1-.773.188,1.55,1.55,0,0,1-.855-.256,1.838,1.838,0,0,1-.63-.688,1.983,1.983,0,0,1,.015-1.88A1.866,1.866,0,0,1,319.2,1879.593Z",
    transform: "translate(-205.108 -1877.378)",
    fill: "#1166af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.618,1879.222h0a2.376,2.376,0,0,0-1.21-.334l-.943-.007-.038,4.781.943.008h.023a2.425,2.425,0,0,0,1.2-.3,2.341,2.341,0,0,0,1.213-2.048,2.374,2.374,0,0,0-.314-1.208A2.419,2.419,0,0,0,325.618,1879.222Zm-1.577.243.355,0a1.781,1.781,0,0,1,.915.254,1.851,1.851,0,0,1,.663.673,1.8,1.8,0,0,1,.236.916,1.732,1.732,0,0,1-.25.9,1.794,1.794,0,0,1-.668.645,1.881,1.881,0,0,1-.925.232l-.356,0Z",
    transform: "translate(-206.902 -1877.413)",
    fill: "#1166af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.861,1879.2a2.2,2.2,0,0,0-2.332-.019,2.4,2.4,0,0,0-.846.89,2.57,2.57,0,0,0-.02,2.444,2.406,2.406,0,0,0,.832.9,2.17,2.17,0,0,0,1.165.344h.018a2.176,2.176,0,0,0,1.148-.325,2.394,2.394,0,0,0,.85-.89,2.567,2.567,0,0,0,.019-2.444A2.385,2.385,0,0,0,331.861,1879.2Zm-1.2,3.982a1.579,1.579,0,0,1-.856-.254,1.83,1.83,0,0,1-.63-.687,2,2,0,0,1,.013-1.888,1.81,1.81,0,0,1,.639-.676,1.577,1.577,0,0,1,.848-.24h.015a1.57,1.57,0,0,1,.855.254,1.839,1.839,0,0,1,.629.688,2,2,0,0,1-.013,1.887h0a1.8,1.8,0,0,1-.639.676A1.674,1.674,0,0,1,330.665,1883.181Z",
    transform: "translate(-208.457 -1877.406)",
    fill: "#1166af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.42,1878.035l-.043,5.426.58,0,.026-3.278,1.5,2.625,1.552-2.6-.026,3.28.58,0,.043-5.424-2.139,3.589Z",
    transform: "translate(-210.667 -1877.147)",
    fill: "#1166af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.469-6.437l-.384.4a1.38,1.38,0,0,0-.937-.465.708.708,0,0,0-.5.192.593.593,0,0,0-.207.448.664.664,0,0,0,.171.431,2.4,2.4,0,0,0,.718.491,2.682,2.682,0,0,1,.906.666,1.213,1.213,0,0,1,.235.73,1.31,1.31,0,0,1-.4.969,1.371,1.371,0,0,1-1,.4A1.755,1.755,0,0,1-1.7-2.358a1.666,1.666,0,0,1-.6-.482l.375-.427a1.306,1.306,0,0,0,.971.516.875.875,0,0,0,.612-.23.712.712,0,0,0,.252-.542.694.694,0,0,0-.167-.457,2.682,2.682,0,0,0-.753-.495,2.411,2.411,0,0,1-.855-.64A1.206,1.206,0,0,1-2.1-5.835a1.173,1.173,0,0,1,.361-.879,1.258,1.258,0,0,1,.912-.35A1.891,1.891,0,0,1,.469-6.437Z",
    transform: "translate(69.767 8.179)",
    fill: "#1166af"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.891 102.924)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -113.01, -103.1)",
    filter: "url(#x)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 129.38,
    height: 25.74,
    rx: 3,
    transform: "translate(113.01 103.1)",
    fill: "#ffc905"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.108-4.384H1.846l-.43,1.29H.044l2.33-6.26h1.2l2.343,6.26H4.542ZM2.194-5.429H3.759L2.973-7.773ZM13.43-5.18a2.215,2.215,0,0,1-.746,1.591,2.62,2.62,0,0,1-1.774.58,2.356,2.356,0,0,1-1.894-.811,3.323,3.323,0,0,1-.69-2.225v-.383a3.753,3.753,0,0,1,.318-1.591,2.384,2.384,0,0,1,.909-1.056,2.547,2.547,0,0,1,1.374-.368,2.552,2.552,0,0,1,1.746.58,2.381,2.381,0,0,1,.765,1.63h-1.29a1.307,1.307,0,0,0-.338-.879,1.25,1.25,0,0,0-.884-.273,1.1,1.1,0,0,0-.965.462,2.59,2.59,0,0,0-.329,1.434v.473A2.773,2.773,0,0,0,9.941-4.53a1.076,1.076,0,0,0,.97.469,1.273,1.273,0,0,0,.892-.273,1.233,1.233,0,0,0,.338-.845Zm3.077-.206H15.479v2.292h-1.29v-6.26h2.326a2.63,2.63,0,0,1,1.711.494,1.707,1.707,0,0,1,.6,1.4,1.926,1.926,0,0,1-.277,1.068,1.891,1.891,0,0,1-.841.682l1.354,2.558v.06H17.68ZM15.479-6.431h1.041a1.065,1.065,0,0,0,.752-.247.884.884,0,0,0,.267-.682.946.946,0,0,0-.252-.7,1.045,1.045,0,0,0-.772-.254H15.479Zm8.008.623H21.011v1.677h2.907v1.036h-4.2v-6.26h4.188V-8.31h-2.9v1.492h2.477ZM28.12-4.384H25.859l-.43,1.29H24.057l2.33-6.26h1.2l2.343,6.26H28.555ZM26.207-5.429h1.565l-.787-2.343ZM34.62-8.31H32.7v5.216h-1.29V-8.31H29.52V-9.355h5.1Zm2.019,5.216h-1.29v-6.26h1.29Zm3.421-1.552,1.419-4.708h1.436l-2.18,6.26H39.388l-2.171-6.26h1.432Zm7.123-1.161H44.7v1.677h2.907v1.036h-4.2v-6.26H47.6V-8.31H44.7v1.492h2.477Zm5.164.2-.671.722v1.789h-1.29v-6.26h1.29v2.838l.568-.778,1.6-2.06h1.587L53.2-6.573l2.287,3.479H53.954Zm4.913,2.511h-1.29v-6.26h1.29Zm6.2,0h-1.29L59.656-7.214v4.119h-1.29v-6.26h1.29l2.515,4.128V-9.355h1.286Zm5.992-.791a2.239,2.239,0,0,1-.985.647,4.123,4.123,0,0,1-1.41.23,2.794,2.794,0,0,1-1.425-.355,2.366,2.366,0,0,1-.946-1.03,3.624,3.624,0,0,1-.342-1.587v-.426a3.849,3.849,0,0,1,.316-1.623,2.338,2.338,0,0,1,.912-1.049,2.626,2.626,0,0,1,1.4-.363A2.615,2.615,0,0,1,68.7-8.91a2.269,2.269,0,0,1,.744,1.546H68.193a1.248,1.248,0,0,0-.381-.787A1.215,1.215,0,0,0,67-8.4a1.144,1.144,0,0,0-1,.494,2.6,2.6,0,0,0-.348,1.471v.4a2.475,2.475,0,0,0,.374,1.488,1.281,1.281,0,0,0,1.1.5,1.431,1.431,0,0,0,1.036-.31V-5.433H66.985v-.95h2.464Zm.957.791v-6.26h1.926a2.925,2.925,0,0,1,1.477.372,2.594,2.594,0,0,1,1.017,1.058,3.262,3.262,0,0,1,.365,1.559v.288a3.272,3.272,0,0,1-.359,1.552,2.571,2.571,0,0,1-1.013,1.053,2.947,2.947,0,0,1-1.475.378ZM71.7-8.31v4.179h.623a1.4,1.4,0,0,0,1.157-.494,2.234,2.234,0,0,0,.408-1.415v-.331a2.27,2.27,0,0,0-.4-1.447,1.4,1.4,0,0,0-1.157-.492Zm9.488,2.227a3.779,3.779,0,0,1-.327,1.621,2.461,2.461,0,0,1-.935,1.075,2.587,2.587,0,0,1-1.4.378,2.6,2.6,0,0,1-1.389-.374,2.485,2.485,0,0,1-.946-1.068,3.671,3.671,0,0,1-.34-1.6v-.31a3.759,3.759,0,0,1,.333-1.627,2.481,2.481,0,0,1,.942-1.079,2.59,2.59,0,0,1,1.391-.376,2.59,2.59,0,0,1,1.391.376,2.481,2.481,0,0,1,.942,1.079,3.749,3.749,0,0,1,.333,1.623Zm-1.307-.284a2.635,2.635,0,0,0-.353-1.5,1.149,1.149,0,0,0-1.006-.512,1.149,1.149,0,0,0-1,.505,2.6,2.6,0,0,0-.357,1.481v.305a2.667,2.667,0,0,0,.353,1.488,1.146,1.146,0,0,0,1.015.529,1.136,1.136,0,0,0,1-.51,2.652,2.652,0,0,0,.353-1.486Zm3.842-2.988,1.608,4.541,1.6-4.541h1.694v6.26H87.325V-4.806l.129-2.954-1.69,4.665h-.886L83.193-7.755l.129,2.95v1.711h-1.29v-6.26ZM93.053-5.3v2.206h-1.29v-6.26H94.2a2.826,2.826,0,0,1,1.24.258,1.9,1.9,0,0,1,.823.733,2.044,2.044,0,0,1,.288,1.081,1.8,1.8,0,0,1-.63,1.451,2.624,2.624,0,0,1-1.744.531Zm0-1.045H94.2a1.133,1.133,0,0,0,.78-.241.876.876,0,0,0,.269-.688,1.033,1.033,0,0,0-.271-.744,1.012,1.012,0,0,0-.748-.292H93.053Zm6.835-.236a3.376,3.376,0,0,0-.447-.034.91.91,0,0,0-.924.477v3.044H97.273V-7.747h1.174l.034.555a1.151,1.151,0,0,1,1.036-.641,1.3,1.3,0,0,1,.387.056Zm.161,1.118a2.759,2.759,0,0,1,.267-1.234,1.952,1.952,0,0,1,.768-.838,2.239,2.239,0,0,1,1.163-.3,2.118,2.118,0,0,1,1.537.576,2.312,2.312,0,0,1,.664,1.565l.009.318a2.432,2.432,0,0,1-.6,1.718,2.077,2.077,0,0,1-1.6.647,2.088,2.088,0,0,1-1.606-.645,2.474,2.474,0,0,1-.6-1.754Zm1.243.088a1.739,1.739,0,0,0,.249,1.014.823.823,0,0,0,.714.351.825.825,0,0,0,.705-.347,1.9,1.9,0,0,0,.254-1.109,1.722,1.722,0,0,0-.254-1.008.825.825,0,0,0-.714-.357.811.811,0,0,0-.705.355A1.935,1.935,0,0,0,101.291-5.375Zm5.158-2.371v4.906a1.664,1.664,0,0,1-.408,1.2,1.553,1.553,0,0,1-1.178.428,2.527,2.527,0,0,1-.615-.073v-.985a2.332,2.332,0,0,0,.391.039q.563,0,.563-.6V-7.747Zm-1.346-1.2a.612.612,0,0,1,.187-.46.7.7,0,0,1,.51-.181.7.7,0,0,1,.51.181.612.612,0,0,1,.187.46.61.61,0,0,1-.191.464.706.706,0,0,1-.505.181.706.706,0,0,1-.505-.181A.61.61,0,0,1,105.1-8.951Zm4.371,5.942a2.284,2.284,0,0,1-1.666-.628,2.231,2.231,0,0,1-.643-1.673v-.12a2.811,2.811,0,0,1,.271-1.253,1.988,1.988,0,0,1,.768-.851,2.154,2.154,0,0,1,1.133-.3,1.931,1.931,0,0,1,1.5.6,2.446,2.446,0,0,1,.548,1.707v.507h-2.963a1.154,1.154,0,0,0,.363.731,1.1,1.1,0,0,0,.768.275,1.341,1.341,0,0,0,1.122-.52l.611.684a1.866,1.866,0,0,1-.757.617A2.483,2.483,0,0,1,109.474-3.008Zm-.142-3.823a.776.776,0,0,0-.6.25,1.3,1.3,0,0,0-.295.717h1.729v-.1a.925.925,0,0,0-.224-.641A.8.8,0,0,0,109.332-6.831Zm4.607,2.821A.815.815,0,0,0,114.5-4.2a.663.663,0,0,0,.224-.5h1.165a1.594,1.594,0,0,1-.258.866,1.7,1.7,0,0,1-.694.611,2.173,2.173,0,0,1-.974.217,2.02,2.02,0,0,1-1.574-.634,2.51,2.51,0,0,1-.576-1.752v-.082a2.481,2.481,0,0,1,.572-1.716,2,2,0,0,1,1.569-.641,1.957,1.957,0,0,1,1.4.5,1.758,1.758,0,0,1,.535,1.322h-1.165a.854.854,0,0,0-.224-.59.745.745,0,0,0-.568-.227.748.748,0,0,0-.656.317,1.834,1.834,0,0,0-.221,1.027v.129a1.858,1.858,0,0,0,.219,1.034A.758.758,0,0,0,113.939-4.01ZM118-8.89v1.144h.8v.912H118v2.322a.554.554,0,0,0,.1.37.5.5,0,0,0,.378.112,1.982,1.982,0,0,0,.365-.03v.942a2.558,2.558,0,0,1-.752.112,1.186,1.186,0,0,1-1.333-1.32V-6.835h-.679v-.912h.679V-8.89Z",
    transform: "translate(5.405 19.351)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreativecopy);
export default __webpack_public_path__ + "static/media/creative copy.79fcdecf661e515e889c3f29c7605515.svg";
export { ForwardRef as ReactComponent };